// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getAISystemMessageRequestToJson, getAISystemMessageResponseFromJson, listAISystemMessagesRequestToJson, listAISystemMessagesResponseFromJson, upsertAISystemMessageRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function upsertAISystemMessage(request) {
    await fetchRpc('conversation.v1.AISystemMessageService/UpsertAISystemMessage', upsertAISystemMessageRequestToJson(request));
}
export function upsertAISystemMessage$(request, options) {
    return defer(() => upsertAISystemMessageWithTransport$(getGlobalTransport(), request, options));
}
export function upsertAISystemMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.AISystemMessageService/UpsertAISystemMessage', upsertAISystemMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getAISystemMessage(request) {
    const raw = await fetchRpc('conversation.v1.AISystemMessageService/GetAISystemMessage', getAISystemMessageRequestToJson(request));
    return getAISystemMessageResponseFromJson(raw);
}
export function getAISystemMessage$(request, options) {
    return defer(() => getAISystemMessageWithTransport$(getGlobalTransport(), request, options));
}
export function getAISystemMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.AISystemMessageService/GetAISystemMessage', getAISystemMessageRequestToJson(request), options)
        .pipe(map(resp => getAISystemMessageResponseFromJson(resp)));
}
export async function listAISystemMessages(request) {
    const raw = await fetchRpc('conversation.v1.AISystemMessageService/ListAISystemMessages', listAISystemMessagesRequestToJson(request));
    return listAISystemMessagesResponseFromJson(raw);
}
export function listAISystemMessages$(request, options) {
    return defer(() => listAISystemMessagesWithTransport$(getGlobalTransport(), request, options));
}
export function listAISystemMessagesWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.AISystemMessageService/ListAISystemMessages', listAISystemMessagesRequestToJson(request), options)
        .pipe(map(resp => listAISystemMessagesResponseFromJson(resp)));
}
